import { useState, type ReactNode } from "react";

export function CollapsedSection({ title, children }: { title: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 dark:border-zinc-700">
      <button
        type="button"
        className="flex w-full items-center justify-between px-3 py-2 text-left hover:bg-gray-50 dark:hover:bg-zinc-800/60"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <span className="text-sm font-semibold text-gray-900 dark:text-zinc-100">{title}</span>
        <span className="text-xs text-gray-400">{open ? "▲" : "▼"}</span>
      </button>
      {open ? (
        <div className="space-y-3 border-t border-gray-100 px-3 py-3 dark:border-zinc-700">{children}</div>
      ) : null}
    </div>
  );
}
